var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListNumberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 4.88571V0.771429L0.771429 1.8M0.771429 12.0856C0.771429 11.8128 0.879796 11.5512 1.07269 11.3584C1.26558 11.1655 1.52721 11.0571 1.8 11.0571C2.07279 11.0571 2.33442 11.1655 2.52731 11.3584C2.7202 11.5512 2.82857 11.8128 2.82857 12.0856C2.82857 12.3895 2.61411 12.7633 2.40891 13.041L0.771429 15.1714L2.82857 15.1709M5.91429 14.1429H17.2286M5.91429 7.97143H17.2286M17.2286 1.8H5.91429",
    stroke: "#0A091B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumberIcon);
export default __webpack_public_path__ + "static/media/list-number-icon.75a49f91f3687fe2090d5aabb33ddea6.svg";
export { ForwardRef as ReactComponent };